// libs
import React, { memo } from 'react';
import ThemeProvider from '@nykaa/ui-components/styles/ThemeProvider';

// helpers
import { getAppTheme } from 'shared/styles/theme';

interface IProvider {
  children: React.ReactNode;
  themeName?: string;
}

function Provider({ children, themeName }: IProvider) {
  const theme = getAppTheme(themeName);
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

export default memo(Provider);
